import {Dispatchable} from "stem-core/src/base/Dispatcher";
import {AuthHelper} from "../../../AuthHelper";
import {isIframe} from "../../../Utils";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";


class OAuth2Client extends Dispatchable {
    constructor(clientId, redirectUri, authServerUrl, loginEndpoint) {
        super();

        this.clientId = clientId;
        this.redirectUri = redirectUri;
        this.authServerUrl = authServerUrl;
        this.loginEndpoint = loginEndpoint;
    }

    setLoginCallback(onLoginCallback) {
        this.onLoginCallback = () => onLoginCallback();
    }

    setLoginErrorCallback(onLoginErrorCallback) {
        this.onLoginErrorCallback = () => onLoginErrorCallback();
    }

    setScope(scope) {
        this.scope = scope;
    }

    setResponseType(responseType) {
        this.responseType = responseType;
    }

    login() {
        const urlParams = new URLSearchParams();
        urlParams.set("client_id", this.clientId);
        urlParams.set("redirect_uri", this.redirectUri);
        // If we're in an iframe, we send the referral merchant's ID in the OAuth state.
        if (isIframe()) {
            urlParams.set("state", JSON.stringify({merchantId: iFrameMerchantService.merchantId}));
        }

        if (this.responseType) {
            urlParams.set("response_type", this.responseType);
        }
        if (this.scope) {
            urlParams.set("scope", this.scope);
        }

        const url = this.authServerUrl + "?" + urlParams.toString();

        AuthHelper.oauth2Login(url);
    }

    async handleLoginResponse(authCode) {
        try {
            await AuthHelper.oauthHandleLoginResponse(this.loginEndpoint, {
                authCode,
                termsAgreed: true,
            });
            this.onLoginCallback();
        } catch (error) {
            this.onLoginErrorCallback()
        }
    }
}

export {OAuth2Client};
